import PropTypes from 'prop-types';

export const MUI_SX_PROP_TYPES = PropTypes.oneOfType([
  PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])
  ),
  PropTypes.func,
  PropTypes.object
]);
